import React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import {Row, Col} from 'reactstrap'

const Section = (props) => {
    console.log(props)
    return (
        <div>section</div>
    )
}
export default Section